import { useContext } from 'react'
import cx from 'classnames'

import { getPrice } from '@lib/helpers'
import { ShopContext } from '@lib/shop'
import { StringsContext } from '@lib/strings'

import Icon from '@components/icon'

interface CartDiscountProps {
  title: string
  amount: number
  quantity?: number
  percent?: number
  className?: string
}

const CartDiscount = ({
  title,
  amount,
  quantity = 1,
  percent,
  className,
}: CartDiscountProps) => {
  const { currency, taxRate } = useContext(ShopContext)
  const strings = useContext(StringsContext)

  return (
    <div
      className={cx('flex justify-between text-sm font-semibold', className)}
    >
      <div className="flex flex-wrap items-center">
        {strings.cartDiscount && (
          <span className="mr-4">{strings.cartDiscount}</span>
        )}

        <span className="flex items-center">
          <Icon name="PriceTag" id="discount" className="w-5 block" />
          <span className="ml-2">
            {title && <span className="hidden sm:inline">{title}</span>}
            {percent && <span>(-{percent}%)</span>}
          </span>
          {quantity && quantity > 1 && (
            <span className="ml-2 font-normal">x{quantity}</span>
          )}
        </span>
      </div>

      <span className="uppercase min-w-[100px] inline-flex justify-end items-center">
        -{currency}
        {getPrice(amount * quantity, taxRate)}
      </span>
    </div>
  )
}

export default CartDiscount
